var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 11.4v4.8h13.2v-4.8h1.2v5.4h-.6v.6H2.4v-.6h-.6v-5.4zm-.6 5.4h-.6v.6h.6zm14.4 0v.6h.6v-.6z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m9.6 13.69 3.643-3.985-.886-.81-2.157 2.36V2.4H9v8.855l-2.157-2.36-.886.81z",
    clipRule: "evenodd"
  })));
};
export default SvgUpload;